module.exports = __webpack_public_path__ + "img/u1264.9ec42dc0.png";